import Alpine from "alpinejs";

const dataset = document.body.dataset;

// Return the projects object with all the splitted data
function fillProjectsWithData(projects, currentId, filterObject) {
    const all = projects;
    const current = all[currentId];
    let prev = [];
    let next = [];
    let splitted = false;

    for (let item in all) {
        const project = all[item];
        if (project == current) {
            splitted = true;
            continue;
        }
        if (splitted) {
            next.push(project);
        } else {
            // We need the prev array in reverse order
            prev.unshift(project);
        }
    }

    const filtered = filterProjects({ projects: { prev, next }, filterObject });
    const aside = getAsideProjects({ prev, next, filtered });

    return { all, current, prev, next, filtered, aside };
}

// Filter project if filter is set, otherwise return all
function filterProjects(data) {
    const filter = data.filterObject;
    const filterKey = filter?.key;
    const filterValue = filter?.value;
    const projects = { prev: data.projects.prev, next: data.projects.next };

    if (!filterKey || !filterValue) {
        return projects;
    }

    let prev = [];
    let next = [];

    for (let index = 0; index < projects.next.length; index++) {
        const item = projects.next[index];
        if (item[filterKey] == filterValue) {
            next.push(item);
        }
    }
    for (let index = 0; index < projects.prev.length; index++) {
        const item = projects.prev[index];
        if (item[filterKey] == filterValue) {
            prev.unshift(item);
        }
    }

    return { prev, next };
}

// Take the filtered projects and the other, merge them and unify them and return the first 3 entries
function getAsideProjects(data) {
    const mergedArray = [...data.filtered.next, ...data.filtered.prev, ...data.next, ...data.prev];
    const uniqueArray = [...new Set(mergedArray)];
    return uniqueArray.slice(0, 3);
}

// Return the object for the prev / next links on the hero image
function getLinks(projects, hasFilter) {
    const filteredPrev = projects.filtered.prev;
    const filteredNext = projects.filtered.next;
    let prevItem = projects.prev[0];
    let nextItem = projects.next[0];

    if (hasFilter) {
        // A filter is set
        prevItem = filteredPrev[0];
        nextItem = filteredNext[0];
    }

    return {
        prev: {
            href: prevItem?.url,
            label: prevItem?.title,
        },
        next: {
            href: nextItem?.url,
            label: nextItem?.title,
        },
    };
}

Alpine.data("item", () => ({
    key: Alpine.$persist(null),
    value: Alpine.$persist(null),
    projects: {
        all: null,
        current: null,
        next: null,
        prev: null,
        aside: null,
        filtered: {
            prev: null,
            next: null,
        },
    },
    mobile: false,
    updMobile() {
        this.mobile = window.innerWidth < 640;
    },
    prev: {
        href: null,
        label: null,
    },
    next: {
        href: null,
        label: null,
    },
    headline: (key, value) => ({
        [":class"]() {
            return this.key == key && "text-terracota";
        },
        ["@click"]() {
            this.key = key;
            this.value = value;
        },
    }),
    init() {
        this.updMobile();
        fetch(dataset.projects)
            .then((response) => response.json())
            .then((data) => {
                this.projects = fillProjectsWithData(data, dataset.current, {
                    key: this.key,
                    value: this.value,
                });
                const { prev, next } = getLinks(this.projects, this.key && this.value);
                this.prev = prev;
                this.next = next;
            });
    },
}));
